module.exports = __webpack_public_path__ + "media/img/event/Sponsor-KUAS-a1c7e966028a9a83c396a3f227dda356.jpg";